import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NestApiProvider } from '../../nest-api';
import {
  RequestEditCareerDto,
  RequestGetEmpHistoryDto,
  RequestGetPositionDto,
  ResponseGetEmpHistoryDto,
  ResponseGetEmpStatus,
  ResponseGetSpvDto,
} from '../dto/career.dto';
import { ResponseData, ResponsePaging } from '../../nest-responses';
import { RequestGetEmpDto, ResponseGetEmpDto } from '../../gd-all-in-one/dto/sf-career.dto';

@Injectable()
export class CareerApi {
  private service: string = '';
  private model: string = 'sfCareer';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }

  public getVal(payload: { empId: string }): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getVal';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public getPhoto(payload: { empId: string }): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getPhoto';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, func, params, body);
  }

  public getSpv(payload: { empId: string }): Observable<ResponseGetSpvDto> {
    const method: string = 'GET';
    const func: string = 'getSpv';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetSpvDto>(method, url, func, params, body);
  }

  public getPosition(payload: RequestGetPositionDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'getPosition';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public getEmpHistory(payload: RequestGetEmpHistoryDto): Observable<ResponseData<ResponseGetEmpHistoryDto>> {
    const method: string = 'GET';
    const func: string = 'getEmpHistory';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetEmpHistoryDto>>(method, url, params, urlParams, body);
  }

  public getEmpStatus(): Observable<ResponseData<ResponseGetEmpStatus[]>> {
    const method: string = 'GET';
    const func: string = 'getEmpStatus';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseGetEmpStatus[]>>(method, url, params, urlParams, body);
  }

  public getResignReason() {
    const method: string = 'GET';
    const func: string = 'getResignReason';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any[]>>(method, url, params, urlParams, body);
  }

  public addCareer(payload): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'addCareer';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public deleteCareer(payload): Observable<ResponseData<any>> {
    const method: string = 'POST';
    const func: string = 'deleteCareer';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public editCareer(payload: RequestEditCareerDto): Observable<ResponseData<any>> {
    const method: string = 'PUT';
    const func: string = 'editCareer';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getEmp(payload: RequestGetEmpDto): Observable<ResponsePaging<ResponseGetEmpDto>> {
    if (payload && typeof payload.empId === 'object') {
      payload.arrEmpId = payload.empId;
      payload.empId = '';
    }

    const method: string = 'POST';
    const func: string = 'getEmp';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<ResponseGetEmpDto>>(method, url, params, urlParams, body);
  }

  public getMgr(payload: { empId: string }): Observable<ResponseGetSpvDto> {
    const method: string = 'GET';
    const func: string = 'getMgr';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetSpvDto>(method, url, func, params, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/career.api.ts